import { InjectionToken } from '@angular/core';

import { DoodReconstructedCart, CartItemWithOrigin } from '@core/models/cart.model';
import { DoodProductModel } from '@core/models/product.model';
import { DoodBasketUserCart } from '@store/basket/basket.model';

/** Runtime VM emitted by `KioskCartProductsListBlock` data sources. */
export type KioskCartProductsListBlockViewModel = {
  reconstructedCart: DoodReconstructedCart[] | undefined;
  reconstructedShareOrderBasket: DoodBasketUserCart[];
  cartProducts: CartItemWithOrigin[];
  allProducts: DoodProductModel[];
  currency: string;
};

export const KIOSK_CART_PRODUCTS_LIST_BLOCK_LOADING_VM: KioskCartProductsListBlockViewModel = {
  reconstructedCart: undefined,
  reconstructedShareOrderBasket: [],
  cartProducts: [],
  allProducts: [],
  currency: 'EUR',
};

export interface KioskCartProductsListBlockDataSource {
  readonly vm$: import('rxjs').Observable<KioskCartProductsListBlockViewModel>;
}

export const KIOSK_CART_PRODUCTS_LIST_BLOCK_DATA_SOURCE =
  new InjectionToken<KioskCartProductsListBlockDataSource>(
    'KIOSK_CART_PRODUCTS_LIST_BLOCK_DATA_SOURCE',
  );
